<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
           <el-form-item label="物资名称">
               <el-input placeholder="请输入物资名称" v-model="selectForm.name"></el-input>
           </el-form-item>
            <el-form-item>
               <el-button plain type="primary" :loading="is_post" @click="selectSubmit()">查询</el-button>
               <el-button plain :loading="is_post" @click="resetSelect()">重置</el-button>
               <el-button plain type="success" @click="goToAdd()" v-can="['btn:material_create']">+ 新增物资</el-button>
           </el-form-item>
       </el-form>
       <!-- 列表 -->
         <el-table v-loading="is_loading" :data="list" :max-height="tableMaxHeight">
           <el-table-column label="物资名称">
               <template slot-scope="scope">
                   <span class="primary_text">{{ scope.row.name }}</span>
               </template>
           </el-table-column>
           <el-table-column label="描述">
               <template slot-scope="scope">
                   <span class="primary_text">{{ scope.row.desc }}</span>
               </template>
           </el-table-column>
           <el-table-column label="操作">
               <template slot-scope="scope">
                   <a style="color:#1890ff;" @click="handleEdit(scope.$index, scope.row)" v-can="['btn:materials_update']">编辑</a>
                   <a style="color:red;margin-left:12px;" @click="handleDel(scope.$index, scope.row)" v-can="['btn:materials_delete']">删除</a>
                   <!-- <a style="color:#1890ff;margin-left:12px;" @click="handleAdd(scope.$index, scope.row)">车辆优惠</a> -->
               </template>
           </el-table-column>
       </el-table>
       <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
           <el-pagination
               style="float: left;position: relative;top: 10px;"
               @current-change="pageChange"
               :current-page.sync="selectForm.pageNum"
               :page-size="selectForm.pageSize"
               :hide-on-single-page="false"
               layout="prev, pager, next, jumper"
               :total="total">
           </el-pagination>
       </footer>

       <!-- 新建车辆管理 -->
       <el-dialog :title="is_add ?'添加物资':'修改物资'" :visible.sync="add_dialog" width="30%" @close="close">
           <el-form label-position="center" ref="addForm" :rules="Rules" label-width="100px" :model="addForm" style="padding: 0 20px;">
               <el-form-item label="物资名称" prop="name">
                       <el-input v-model="addForm.name" placeholder="请输入物资名称" maxlength="11" show-word-limit></el-input>
               </el-form-item>
               <el-form-item label="描述">
                       <el-input placeholder="描述" v-model="addForm.desc" :autosize="{ minRows:4, maxRows:6}" maxlength="200" show-word-limit type="textarea"></el-input>
               </el-form-item>
               <el-form-item label="" v-if='is_add'>
                       <el-button plain type="primary" @click="addSubmit()">保 存</el-button>
                       <el-button plain @click="addSelect()">重 置</el-button>
               </el-form-item>
               <el-form-item v-else>
                       <el-button type="warning" plain :loading="is_post" @click="editSubmit">提交修改</el-button>
               </el-form-item>
           </el-form>
       </el-dialog>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import {stringTrim} from '@/utils/elvalid'
import { re } from 'mathjs'
import can from "@/directive/can/index.js"

   export default {
    directives:{can},
       data(){
           return{
               is_ok: false,
               is_post: false,
               is_loading:false,
               selectForm:{
                   pageNum:1,
                   pageSize: 15,
                   name:""
               },
               list:[],
               total:0,
               tableMaxHeight: 0,
               
               addForm:{
                   desc:'',
                   name:'',
               },
                Rules:{
                   name:[
                       {required: true, message: '请输入物资名称', trigger: 'blur'}
                   ],
               },
               add_dialog:false,
               is_add:false,
               is_dialog:false,
               is_time_price:false,
               discount_list:[],
               plate:'',
               id:'',
               add_prcie:false
           }
       },
       mounted(){
           this.getData(true)
       },
       methods:{
           pageChange(page){
               this.selectForm.pageNum = page;
               this.getData();
           },
           getData(is_init = false){
               if(!is_init){
                   this.is_loading = true;
                   this.is_post = true;
               }
               request.post("/material/list",this.selectForm).then(res=>{
                   this.list=res.data.list
                   this.total=res.data.total
                   this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                   if(!is_init){
                       this.is_post = false;
                       this.is_loading = false;
                   }else{
                       this.is_ok = true;
                   }
               }).catch((err)=>{
                   this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
               })
           },
           //查询
           selectSubmit(){
               this.getData(false)
           },
           //重置
           resetSelect(){
               this.selectForm={
                   name:''
               }
           },
           //新建
           goToAdd(){
               this.addForm={
                   desc:'',
                   name:'',
               },
               this.add_dialog=true;
               this.is_add=true;
           },
           //编辑
           handleEdit(i,r){
               this.is_add=false
               this.add_dialog=true
               this.addForm.id=r.id
               this.addForm.name=r.name
               this.addForm.desc=r.desc
              if(r.status==1){
                   this.addForm.status=true;
              }else{
                   this.addForm.status=false;
              }
               
           },
           //删除
           handleDel(i,r){
               this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(() => {
                   let id=r.id
                   request.post(`/material/delete/${id}`,'').then(res=>{
                       if(res.code==200){
                           this.$message.success('删除成功！')
                           this.getData(true);
                       }else{
                           this.$message.error(res.msg)
                       }
                   })
               })
           },
           //提交
           addSubmit(){
                this.$refs["addForm"].validate(valid=>{
                   if(!valid) return false;
                   request.post('/material/create',this.addForm).then(res=>{
                       if(res.code==200){
                           this.$message.success('添加成功！')
                           this.add_dialog=false;
                           this.getData();
                       }else{
                           this.$message.error(res.msg)
                       }
                   })
                })
           },
           //提交重置
           addSelect(){
               this.addForm={
                  name:'',
                  desc:""
               }
           },
           //提交修改
           editSubmit(){
               this.$refs["addForm"].validate(valid=>{
                   if(!valid) return false;
                   request.post('/material/update',this.addForm).then(res=>{
                       if(res.code==200){
                           this.$message.success('修改成功！')
                           this.add_dialog=false;
                           this.getData();
                       }else{
                           this.$message.error(res.msg)
                       }
                   })
                })
           },
           close(){},
       }
   }
</script>

